import React from 'react';
import PropTypes from 'prop-types';

import { Section, Container, H3, Image } from 'components/atoms';
import { PSPMarkdownContent, SectionHeader } from 'components/molecules';

import './AlternateContentSection.scss';

const AlternateContentSection = ({ props, theme = 'light' }) => {
	const color = theme === 'dark' ? 'white' : 'black';
	const { title, description, content } = props;

	return (
		<Section className={` ${theme}`}>
			<SectionHeader
				title={title}
				titleProps={{
					className: 'header-title',
				}}
				additionalProps={props.additionalProps}
				description={description}
			/>
			<Container className="alternate-content-section">
				{content &&
					content.map((item, index) => (
						<div
							key={index}
							className={`alternate-content-section__row ${
								index % 2 === 0 ? 'even' : 'odd'
							}`}
						>
							{item.image && (
								<Image
									src={item.image}
									alt={
										item.title ||
										`Alternate Content Image ${index}`
									}
									className="alternate-content-section__image"
								/>
							)}
							<div>
								{item.title && (
									<H3
										className="alternate-content-section__title"
										color={color}
									>
										{item.title}
									</H3>
								)}
								<PSPMarkdownContent
									content={item.description}
									additionalProps={{
										paragraph: { color: 'black' },
									}}
								/>
							</div>
						</div>
					))}
			</Container>
		</Section>
	);
};

AlternateContentSection.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	content: PropTypes.arrayOf(
		PropTypes.shape({
			image: PropTypes.string,
			title: PropTypes.string,
			description: PropTypes.string,
		})
	),
	theme: PropTypes.string,
	className: PropTypes.string,
};

export default AlternateContentSection;
